import Swiper from 'swiper/bundle';

common.View.create('website_blog::website.modules.blog.Show', {
    swiperInstance: null,

    onDOMLoad() {
        this.initSwiperOnResize();
        this.setupResizeListener();
    },

    initSwiperOnResize() {
        const swiperEl = $(this.element).find('.relatedBlogsSwiper')[0];
        if (!swiperEl) return;

        const isMobile = window.innerWidth < 768;

        // If mobile and not initialized, create swiper
        if (isMobile && !this.swiperInstance) {
            const nextButton = swiperEl.querySelector('.swiper-button-next');

            this.swiperInstance = new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 16,
                centeredSlides: false,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                navigation: {
                    nextEl: nextButton,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                    },
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 24,
                    },
                },
            });
        }
        // If desktop and initialized, destroy swiper
        else if (!isMobile && this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    },

    setupResizeListener() {
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.initSwiperOnResize();
            }, 100);
        });
    },
});
